module.exports = __webpack_public_path__ + "static/media/grillades.0eda24c6.jpg";